import styles from "styles/store.module.css"

const Information = ({ title, value, isClass, isVisibleIcon, openModelMap }) => {
	return (
		<div className={styles["panel-item"]}>
			{isVisibleIcon && <span className={`${styles["panel-item__imagen"]} ${styles[isClass]}`}></span>}
			<div className={styles["feature--details"]}>
				<p className={styles["panel-item__title"]}>{title}</p>
				{
					title === "Teléfono" ? (
						value?.length > 0 && value.map((el, index) => {
							if (el.type === "separador") {
								return el.caracter;
							} else {
								const rawPhone = el.phone.startsWith("+") ? el.phone.slice(1) : el.phone; // eliminar + si está
								let phoneHref = "";
								let phoneDisplay = "";

								if (rawPhone.startsWith("600")) {
									// fijo 600 sin +56
									phoneHref = rawPhone;
									phoneDisplay = rawPhone;
								} else if (rawPhone.startsWith("9")) {
									// celular con +56
									phoneHref = `+56${rawPhone}`;
									phoneDisplay = `+56${rawPhone}`;
								} else if (rawPhone.startsWith("2")) {
									// fijo con +56
									phoneHref = `+56${rawPhone}`;
									phoneDisplay = `+56${rawPhone}`;
								} else {
									// fallback, mostrar sin prefijo extra
									phoneHref = rawPhone;
									phoneDisplay = rawPhone;
								}

								return (
									<a key={index} href={`tel:${phoneHref}`} className={styles["panel-item__value"]}>
										{phoneDisplay}
									</a>
								);
							}
						})
					) : title === "N.° de local" ? (
						<a href="!#" onClick={(event) => openModelMap(event)} className={`${styles["panel-item__value"]} ${styles["panel-item__value--red"]}`}>{value}</a>
					) : (
						<p className={styles["panel-item__value"]}>{value}</p>
					)
				}
			</div>
		</div>
	)
}

export default Information